import {
  type BreadcrumbData,
  type ContentDataItem,
  type FacetData,
  type PaginationData,
  type SearchResultRow,
} from "../../utils/models";
import { type ProductGroup, type SearchDisplayMode } from "../models";
import { type SortState } from "./reducer/sortReducer";
import { type SeriesTreeState } from "./reducer/seriesTreeReducer";
import { type TabularColumnDefDTO, type TechnicalInfoDataDTO } from "~/Search/dto/SearchResultsDTO";
import type { FilterConfig } from "~/Search/filterConfigModels";

export interface SearchPageState {
  init: boolean;
  inFlight: boolean;

  text: string;
  currentPage: number;

  pagination: PaginationData;
  results: SearchResultRow[];
  firstResultProductCode: string | null;

  contentResults: ContentDataItem[];
  contentPagination: PaginationData;
  contentPage: number;

  /**
   * key: code
   */
  facetValues: Record<string, FacetData>;
  assistantValues: string[];

  breadcrumbs: BreadcrumbData[];

  // Configuration, comes from facets/configuration/XXX endpoint
  filterConfig: FilterConfig; // Andre

  // Configuration, comes from facets/configuration/XXX endpoint
  tabularViewColConfig: TabularColumnDefDTO[]; // Andre

  // Configuration, comes from facets/configuration/XXX endpoint
  filterConfigImperial: FilterConfig; // Andre

  // Configuration, comes from facets/configuration/XXX endpoint
  tabularViewColConfigImperial: TabularColumnDefDTO[]; // Andre

  rawTechFilterValues: { [code: string]: number };
  appliedTechFilterValues: { [code: string]: number };

  sort: SortState;

  /**
   *  @deprecated - try not using this
   */
  fullTaxonomy: ProductGroup[];

  selectedProductGroups: string[];
  isSelectionAssistant?: SelectionAssistantType;
  seriesTree: SeriesTreeState;

  resultsViewMode: SearchDisplayMode;

  hasTubularResults: boolean;

  technicalInfo: TechnicalInfoDataDTO | null;

  salesCampaignFilter: string[];
  showOnlyRelevant: boolean;
  hasCampaignResults: boolean;

  productsOnSale: string[];
  productsOnSaleInFlight: boolean;
}

export enum SelectionAssistantType {
  ROTARY = "ROTARY",
  HOUSINGS = "HOUSINGS",
  LINEAR = "LINEAR",
}
